(function () {
  var header = document.querySelector('.site-header');
  var navBar = document.querySelector('.nav-bar');
  var announcementBar = document.querySelector('.announcement-bar');
  var hamburger = document.querySelector('.nav-hamburger');
  var navItems = document.querySelectorAll('.nav-item[data-menu]');
  var scrim = document.querySelector('.menu-scrim');

  var menuIsOpen = false;

 function updateSolidState() {
  if (!header) return;

  var scrolledPastHero = header.dataset.pastHero === 'true';

  header.classList.toggle(
    'is-solid',
    menuIsOpen || scrolledPastHero
  );
}

  function closeAllMenus() {
    navItems.forEach(function (item) {
      item.classList.remove('is-open');
    });
    menuIsOpen = false;
    updateSolidState();
    if (scrim) scrim.classList.remove('is-visible');
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

 navItems.forEach(function (item) {
  var trigger = item.querySelector(':scope > .nav-link');
  if (!trigger) return;

  // DESKTOP: open mega menu on hover
  item.addEventListener('mouseenter', function () {
    if (isMobile()) return;

    closeAllMenus();

    item.classList.add('is-open');
    menuIsOpen = true;
    updateSolidState();

    if (scrim) {
      scrim.classList.add('is-visible');
    }
  });

  // DESKTOP: close when mouse leaves
  item.addEventListener('mouseleave', function () {
    if (isMobile()) return;

    item.classList.remove('is-open');
    menuIsOpen = false;
    updateSolidState();

    if (scrim) {
      scrim.classList.remove('is-visible');
    }
  });

    // MOBILE:
  // Menu text -> parent page
  trigger.addEventListener('click', function (e) {

  // Arrow click on mobile = submenu
  if (isMobile() && e.target.closest('.nav-link__arrow')) {
    return;
  }

  // Text/title click = parent page
  var url = trigger.getAttribute('data-menu-url');

  if (url) {
    window.location.href = url;
  }

});
  // MOBILE:
  // Arrow/image -> open submenu
  var arrow = trigger.querySelector('.nav-link__arrow');

  if (arrow) {
    arrow.addEventListener('click', function (e) {
      if (!isMobile()) return;

      e.preventDefault();
      e.stopPropagation();

      var wasOpen = item.classList.contains('is-open');

      closeAllMenus();

      if (!wasOpen) {
        item.classList.add('is-open');
        menuIsOpen = true;
        updateSolidState();

        if (scrim) {
          scrim.classList.add('is-visible');
        }
      }
    });
  }
});

  document.querySelectorAll('.nav-item[data-menu="art-culture"] > .nav-link, .nav-item[data-menu="stewardship"] > .nav-link')
    .forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        window.location.href = link.getAttribute('href');
      });
    });

  if (scrim) {
    scrim.addEventListener('click', closeAllMenus);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllMenus();
  });

  if (hamburger) {
    hamburger.addEventListener('click', function () {
      var isOpen = document.body.classList.toggle('nav-open');
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (!isOpen) closeAllMenus();
    });
  }

  document.addEventListener('click', function (e) {
    if (isMobile()) return;
    if (!menuIsOpen) return;
    if (header.contains(e.target)) return;
    closeAllMenus();
  });

  window.addEventListener('resize', function () {
    if (!isMobile()) {
      document.body.classList.remove('nav-open');
    }
  });

  document.querySelectorAll('[data-carousel-track]').forEach(function (track) {
    var name = track.dataset.carouselTrack;
    var wrap = track.closest('[data-carousel]');
    var prev = (wrap && wrap.querySelector('[data-carousel-prev]')) ||
      (name && document.querySelector('[data-carousel-prev="' + name + '"]'));
    var next = (wrap && wrap.querySelector('[data-carousel-next]')) ||
      (name && document.querySelector('[data-carousel-next="' + name + '"]'));
    var scrollByOne = function (dir) {
      var slide = track.querySelector(':scope > *');
      var amount = slide ? slide.getBoundingClientRect().width : track.clientWidth;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); scrollByOne(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); scrollByOne(1); });
  });

  // Quick-add buttons sit inside product-card links — stop the click from
  // also following the card through to the PDP.
  document.querySelectorAll('.product-card-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  // Mouse-drag panning for any native overflow-x:auto track. Touch and


  // Dot indicators synced to a named carousel track's scroll position.
  document.querySelectorAll('[data-dots-for]').forEach(function (dotsEl) {
    var track = document.querySelector('[data-carousel-track="' + dotsEl.dataset.dotsFor + '"]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll(':scope > *'));
    dotsEl.innerHTML = '';
    var dots = slides.map(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dotsEl.appendChild(b);
      return b;
    });
    var syncActive = function () {
      var trackLeft = track.getBoundingClientRect().left;
      var closest = 0, closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      dots.forEach(function (b, i) { b.classList.toggle('is-active', i === closest); });
    };
    track.addEventListener('scroll', syncActive, { passive: true });
    syncActive();
  });

  // Generic dropdown toggle (e.g. Filter / Sort on the collection page).
  document.querySelectorAll('[data-dropdown-trigger]').forEach(function (trigger) {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = panel.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.querySelectorAll('[data-dropdown-trigger]').forEach(function (t) {
        if (t === trigger) return;
        t.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.classList.remove('is-open');
      });
    });
  });

  // Collection availability filter
(function () {
  var filters = document.querySelectorAll('[data-filter-input]');

  if (!filters.length) return;

  if (window.location.pathname.indexOf('/collections/') !== 0) return;

  filters.forEach(function (input) {
    input.addEventListener('change', function () {
      var filterType = input.getAttribute('data-filter-type');

      /* AVAILABILITY — keep existing behaviour */
      if (filterType === 'availability') {
        var url = new URL(window.location.href);

        url.searchParams.delete('filter.v.availability');

        if (input.checked) {
          url.searchParams.set(
            'filter.v.availability',
            input.value
          );
        } else {
          url.searchParams.set(
            'filter.v.availability',
            '1'
          );
        }

        window.location.href = url.toString();
        return;
      }

      /* COLOUR / STYLE — Shopify filter URL */
      if (input.checked) {
        var addUrl = input.getAttribute('data-url');

        if (addUrl) {
          window.location.href = addUrl;
        }

        return;
      }

      var removeUrl = input.getAttribute('data-url-remove');

      if (removeUrl) {
        window.location.href = removeUrl;
      }
    });
  });

  /* Fresh collection = In Stock */
  var url = new URL(window.location.href);

  var availability = url.searchParams.get(
    'filter.v.availability'
  );

  if (!availability) {
    url.searchParams.set(
      'filter.v.availability',
      '1'
    );

    window.location.replace(url.toString());
    return;
  }

  /* Fix old URLs containing both 1 and 0 */
  var allParams = window.location.search;

  if (
    allParams.includes('filter.v.availability=1') &&
    allParams.includes('filter.v.availability=0')
  ) {
    url.searchParams.delete(
      'filter.v.availability'
    );

    url.searchParams.set(
      'filter.v.availability',
      '1'
    );

    window.location.replace(url.toString());
  }
})();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dropdown-trigger], [data-dropdown-panel]')) return;
    document.querySelectorAll('[data-dropdown-panel].is-open').forEach(function (p) {
      p.classList.remove('is-open');
    });
    document.querySelectorAll('[data-dropdown-trigger]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  });

  // Mobile mega-menu drill-down: back button returns to the top-level list.
  document.querySelectorAll('[data-submenu-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.nav-item');
      if (item) item.classList.remove('is-open');
    });
  });

  // Click-to-play video (post pages).
  document.querySelectorAll('.post-video-wrap').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var playBtn = wrap.querySelector('.post-play');
    if (!video || !playBtn) return;
    playBtn.addEventListener('click', function () {
      video.setAttribute('controls', '');
      video.play();
      wrap.classList.add('is-playing');
    });
  });


var hero = document.querySelector('.hero');
var pageWrapper = document.querySelector('.page-wrapper');

if (header && pageWrapper) {

  function checkHeaderScroll() {

    var scrollTop = pageWrapper.scrollTop || 0;

    // Homepage / transparent header
    if (header.classList.contains('site-header--transparent')) {

      var pastHero;

      if (hero && navBar) {
        pastHero =
          scrollTop > (hero.offsetHeight - navBar.offsetHeight);
      } else {
        pastHero = scrollTop > 50;
      }

      header.classList.toggle('is-fixed', pastHero);
      header.dataset.pastHero = pastHero ? 'true' : 'false';

      if (announcementBar) {
        announcementBar.classList.toggle('is-hidden', pastHero);
      }

    }

    // Inner pages / normal header
    else {

      var shouldFix = scrollTop > 50;

      header.classList.toggle('is-fixed', shouldFix);
      header.dataset.pastHero = shouldFix ? 'true' : 'false';

      if (announcementBar) {
        announcementBar.classList.toggle('is-hidden', shouldFix);
      }
    }

    updateSolidState();
  }

  checkHeaderScroll();

  pageWrapper.addEventListener('scroll', checkHeaderScroll, {
    passive: true
  });

  window.addEventListener('resize', checkHeaderScroll);
}
})();


/* ================================
   CONTINUOUS INFINITE BAG SLIDER
   Desktop + Mobile + Touch Support
================================ */

jQuery(document).ready(function ($) {

    var $slider = $('.marquee-track');

    if (!$slider.length) return;

    if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
    }

    $slider.slick({

        slidesToShow: 9,
        slidesToScroll: 1,
        infinite: true,

        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        cssEase: 'linear',

        arrows: false,
        dots: false,

        draggable: true,
        swipe: true,
        touchMove: true,
        swipeToSlide: true,
        touchThreshold: 5,

        waitForAnimate: false,
       pauseOnHover: false,
       pauseOnFocus: false,

        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    dots: true
                }
            }
        ]
    });

    // Pause continuous movement during touch/drag.
    // Resume when the interaction ends.
    var resumeTimer;

   
var resumeTimer;
var isInteracting = false;

$slider.on('touchstart.marqueeInteraction', function () {
    isInteracting = true;
    clearTimeout(resumeTimer);

    if ($slider.hasClass('slick-initialized')) {
        $slider.slick('slickPause');
    }
});

$slider.on('mousedown.marqueeInteraction', function () {
    isInteracting = true;
    clearTimeout(resumeTimer);

    if ($slider.hasClass('slick-initialized')) {
        $slider.slick('slickPause');
    }
});

$(document).on(
    'touchend.marqueeInteraction touchcancel.marqueeInteraction mouseup.marqueeInteraction',
    function () {
        if (!isInteracting) return;

        isInteracting = false;
        clearTimeout(resumeTimer);

        resumeTimer = setTimeout(function () {
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('slickPlay');
            }
        }, 400);
    }
);


});


/* ================================
   ART GALLERY SLIDER
================================ */

jQuery(document).ready(function ($) {

    var $slider = $('.editorial-strip-inner');

    function initEditorialSlider() {

        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }

        if (window.innerWidth <= 767) {

            $slider.slick({
                slidesToShow: 2,
                slidesToScroll: 2,

                variableWidth: false,
                infinite: true,

                arrows: false,
                dots: true,

                autoplay: true,
              autoplaySpeed: 0,
              speed: 7000,
              cssEase: 'linear',

              draggable: true,
              swipe: true,
              touchMove: true,
              swipeToSlide: true,

              pauseOnHover: true,
              pauseOnFocus: false,
              waitForAnimate: false
            });

        } else {

           
$slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,

    variableWidth: true,
    infinite: true,

    arrows: false,
    dots: true,

    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    cssEase: 'linear',

    draggable: true,
    swipe: true,
    touchMove: true,
    swipeToSlide: true,

    pauseOnHover: true,
    pauseOnFocus: false,
    waitForAnimate: false
});


        }
    }

    initEditorialSlider();

    var resizeTimer;

    $(window).on('resize', function () {

        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
            initEditorialSlider();
        }, 200);

    });

});

$(document).on('click', '.editorial-video .play-badge', function (e) {

    e.preventDefault();
    e.stopPropagation();

    var $badge = $(this);
    var video = $badge.siblings('.editorial-video-file')[0];

    if (!video) return;

    if (video.paused) {

        video.play();

        $badge.hide();

    } else {

        video.pause();

        $badge.show();

    }
});

jQuery(document).ready(function ($) {

    var $slider = $('.collection-grid-track');

    function initCollectionSlider() {

        if (window.innerWidth <= 767) {

            if (!$slider.hasClass('slick-initialized')) {

                $slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,

                    variableWidth: false,

                    infinite: true,
                    arrows: true,
                    dots: true,
                    autoplay: false,
                    speed: 600,
                    swipeToSlide: true
                });

            }

        } else {

            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

        }
    }

    initCollectionSlider();

    $(window).on('resize', function () {
        initCollectionSlider();
    });

});

jQuery(document).ready(function ($) {

    var $slider = $('.cd-triptych');

    function initCollectionSlider() {

        if (window.innerWidth <= 767) {

            if (!$slider.hasClass('slick-initialized')) {

                $slider.slick({
                   dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1.2, /* Shows one full slide and part of the next */
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000,
                pauseOnHover: false,
                draggable: true,
                swipe: true,
                touchThreshold: 10,
                });

            }

        } else {

            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

        }
    }

    initCollectionSlider();

    $(window).on('resize', function () {
        initCollectionSlider();
    });

});

jQuery(function ($) {

    var $carousel = $('.craft-carousel-track');

    if ($carousel.length && typeof $.fn.slick === 'function') {

        if (!$carousel.hasClass('slick-initialized')) {

            $carousel.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: false,
                adaptiveHeight: true,

               
            });

        }

    }

});

const editorialSlider = document.querySelector('.editorial-strip-inner');

if (editorialSlider) {

    // Play / pause when play icon is clicked
    editorialSlider.addEventListener('click', function (e) {

        const playIcon = e.target.closest('.play-badge');

        if (playIcon) {
            e.preventDefault();
            e.stopPropagation();

            const videoCard = playIcon.closest('.editorial-video');
            const video = videoCard?.querySelector('.editorial-video-file');

            if (!video) return;

            if (video.paused) {
                video.play()
                    .then(function () {
                        playIcon.style.display = 'none';
                    })
                    .catch(function (error) {
                        console.log('Video could not play:', error);
                    });
            } else {
                video.pause();
                playIcon.style.display = 'block';
            }

            return;
        }

        // Play / pause when video itself is clicked
        const video = e.target.closest('.editorial-video-file');

        if (video) {
            e.preventDefault();
            e.stopPropagation();

            const videoCard = video.closest('.editorial-video');
            const playIcon = videoCard?.querySelector('.play-badge');

            if (video.paused) {
                video.play()
                    .then(function () {
                        if (playIcon) {
                            playIcon.style.display = 'none';
                        }
                    })
                    .catch(function (error) {
                        console.log('Video could not play:', error);
                    });
            } else {
                video.pause();

                if (playIcon) {
                    playIcon.style.display = 'block';
                }
            }
        }

    });


    // Show play icon again when ANY video finishes
    editorialSlider.addEventListener('ended', function (e) {

        if (!e.target.classList.contains('editorial-video-file')) {
            return;
        }

        const video = e.target;
        const videoCard = video.closest('.editorial-video');
        const playIcon = videoCard?.querySelector('.play-badge');

        if (playIcon) {
            playIcon.style.display = 'block';
        }

    }, true);

}

document.querySelectorAll('.footer-mobile-title').forEach(function (button) {

    button.addEventListener('click', function () {

        const item = button.closest('.footer-mobile-item');

        item.classList.toggle('active');

    });

});

document.querySelectorAll('.accordion-title').forEach(function(button) {

    button.addEventListener('click', function() {

        const currentItem = this.closest('.accordion-item');

        document.querySelectorAll('.accordion-item').forEach(function(item) {

            if (item !== currentItem) {
                item.classList.remove('active');
                item.querySelector('.accordion-icon').textContent = '+';
            }

        });

        currentItem.classList.toggle('active');

        const icon = this.querySelector('.accordion-icon');

        icon.textContent = currentItem.classList.contains('active')
            ? '−'
            : '+';

    });

});


document.addEventListener('DOMContentLoaded', function () {

  const swatches = document.querySelectorAll('.pdp-swatch');
  const gallery = document.querySelector('.pdp-gallery');

  if (!swatches.length || !gallery) return;

  swatches.forEach(function (swatch) {

    swatch.addEventListener('click', function () {

      const variantId = this.dataset.variantId;

      if (!variantId) return;

      /* Selected swatch */
      swatches.forEach(function (item) {
        item.classList.remove('is-selected');
      });

      this.classList.add('is-selected');


      /* Find image belonging to this variant */
      const images = gallery.querySelectorAll('.pdp-gallery-image');

      let targetImage = null;

      images.forEach(function (image) {

        const imageVariants = image.dataset.variantIds;

            if (imageVariants && imageVariants.split(',').includes(variantId)) {
      targetImage = image;
    }

      });

      if (!targetImage) return;


      /* Move selected variant image to TOP */
      gallery.prepend(targetImage);


      /* Scroll gallery to top */
      gallery.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

    });

  });

});


/// Product add in cart — Horizon sync

document.addEventListener('DOMContentLoaded', function () {

  const quickAddButtons = document.querySelectorAll('[data-quick-add]');

  if (!quickAddButtons.length) return;

  /*
   * Load Shopify Standard Events.
   * Horizon uses this event to refresh the native cart drawer.
   */
  import('https://cdn.shopify.com/storefront/standard-events.js')
    .then(function (StandardEvents) {

      const CartLinesUpdateEvent = StandardEvents.CartLinesUpdateEvent;

      /*
       * Sync + / ✓ state with the REAL cart.
       */
      function syncQuickAddButtons(cart) {

        const cartVariantIds = new Set(
          (cart.items || []).map(function (item) {
            return String(item.variant_id);
          })
        );

        quickAddButtons.forEach(function (button) {

          const variantId = String(button.dataset.variantId || '');

          const isInCart = cartVariantIds.has(variantId);

          button.classList.toggle('is-added', isInCart);
          button.disabled = false;

        });

      }


      /*
       * Update Horizon header cart bubble.
       */
      function updateHeaderCart(itemCount) {

        const cartIcons = document.querySelectorAll(
          '.header-actions__cart-icon'
        );

        cartIcons.forEach(function (cartIcon) {

          cartIcon.classList.toggle(
            'header-actions__cart-icon--has-cart',
            itemCount > 0
          );

        });

        const cartBubbles = document.querySelectorAll('.cart-bubble');

        cartBubbles.forEach(function (bubble) {

          const count = bubble.querySelector(
            '.cart-bubble__text-count'
          );

          if (count) {
            count.textContent = itemCount;
          }

          bubble.classList.toggle(
            'visually-hidden',
            itemCount === 0
          );

        });

      }


      /*
       * Initial sync.
       * If product is already in cart after page load,
       * show ✓ immediately.
       */
      fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {

          syncQuickAddButtons(cart);
          updateHeaderCart(cart.item_count);

        });


      /*
       * Quick Add
       */
      quickAddButtons.forEach(function (button) {

        button.addEventListener('click', function (event) {

          event.preventDefault();
          event.stopPropagation();

          if (button.classList.contains('is-added')) {
            return;
          }

          const variantId = button.dataset.variantId;

          if (!variantId) {
            console.error('No variant ID found');
            return;
          }

          button.disabled = true;


          /*
           * Tell Horizon a cart update has started.
           */
          const deferred = CartLinesUpdateEvent.createPromise();

          document.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [
                {
                  merchandiseId: String(variantId),
                  quantity: 1
                }
              ],
              promise: deferred.promise
            })
          );


          /*
           * Actually add product.
           */
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1
                }
              ]
            })
          })

            .then(function (response) {

              if (!response.ok) {
                throw new Error('Unable to add product to cart');
              }

              return response.json();

            })

            /*
             * Get REAL updated cart.
             */
            .then(function () {

              return fetch('/cart.js', {
                headers: {
                  'Accept': 'application/json'
                }
              });

            })

            .then(function (response) {
              return response.json();
            })

            .then(function (cart) {

              /*
               * + → ✓
               */
              syncQuickAddButtons(cart);

              /*
               * Header bubble update.
               */
              updateHeaderCart(cart.item_count);


              /*
               * Tell Horizon cart update succeeded.
               * This triggers native cart drawer refresh.
               */
           deferred.resolve({
  cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
  detail: {
    items: cart.items,
    itemCount: cart.item_count,
    source: 'custom-quick-add',
    didError: false
  }
});

/*
 * Open Horizon cart drawer AFTER cart has been updated.
 */
setTimeout(function () {

  if (
    window.Shopify &&
    Shopify.actions &&
    typeof Shopify.actions.openCart === 'function'
  ) {
    Shopify.actions.openCart();
    return;
  }

  /*
   * Fallback for Horizon cart drawer.
   */
  const cartDrawer = document.querySelector('#cart-drawer');

  if (cartDrawer && typeof cartDrawer.open === 'function') {
    cartDrawer.open();
  }

}, 100);

            })

            .catch(function (error) {

              console.error('Quick add error:', error);

              /*
               * Tell Horizon the update failed.
               */
              deferred.reject(error);

              button.disabled = false;

            });

        });

      });


      /*
       * IMPORTANT:
       * When product is removed/quantity changed inside
       * the native Horizon cart drawer, sync the + / ✓ buttons.
       */
      document.addEventListener(
        'shopify:cart:lines-update',
        function (event) {

          if (!event.promise) return;

          event.promise
            .then(function (result) {

              const detail = result && result.detail;

              if (detail && detail.items) {

                const cart = {
                  items: detail.items
                };

                syncQuickAddButtons(cart);

              } else {

                return fetch('/cart.js', {
                  headers: {
                    'Accept': 'application/json'
                  }
                })
                  .then(function (response) {
                    return response.json();
                  })
                  .then(function (cart) {

                    syncQuickAddButtons(cart);
                    updateHeaderCart(cart.item_count);

                  });

              }

            })
            .catch(function (error) {

              if (error && error.name !== 'AbortError') {
                console.warn(
                  'Cart sync error:',
                  error
                );
              }

            });

        }
      );

    })

    .catch(function (error) {

      console.error(
        'Shopify Standard Events failed to load:',
        error
      );

    });

});



(function () {
  function mobileHeaderScroll() {
    if (window.innerWidth > 749) return;

    var header = document.querySelector('.site-header');
    var announcementBar = header
      ? header.querySelector('.announcement-bar')
      : null;

    if (!header) return;

    var scrollTop = window.scrollY || window.pageYOffset || 0;
    var shouldFix = scrollTop > 50;

    /* Header fixed */
    header.classList.toggle('is-fixed', shouldFix);

    /* Announcement hide */
    if (announcementBar) {
      announcementBar.classList.toggle('is-hidden', shouldFix);
    }
  }

  mobileHeaderScroll();

  window.addEventListener('scroll', mobileHeaderScroll, {
    passive: true
  });

  window.addEventListener('resize', mobileHeaderScroll);
})();




(function () {
  var wasMobile = window.innerWidth <= 767;

  window.addEventListener('resize', function () {
    var isMobile = window.innerWidth <= 767;

    if (wasMobile && !isMobile) {
      requestAnimationFrame(function () {
        window.scrollTo(0, 0);
      });
    }

    wasMobile = isMobile;
  });
})();



/* =========================================================
   CART DRAWER — CONTINUE SHOPPING
   ========================================================= */

document.addEventListener('click', async function (event) {
  var clickedElement = event.target.closest('a, button');

  if (!clickedElement) return;

  var text = clickedElement.textContent.trim().toLowerCase();

  if (text !== 'continue shopping') return;

  var cartDrawer = document.querySelector('#cart-drawer');

  if (!cartDrawer) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  var destination = clickedElement.href || '/collections/all';

  try {
    await cartDrawer.close();

    sessionStorage.removeItem('theme-drawer-open');

    window.location.href = destination;
  } catch (error) {
    console.error('Cart drawer close error:', error);

    sessionStorage.removeItem('theme-drawer-open');

    window.location.href = destination;
  }
});


/* =========================================================
   PRODUCT ADD TO CART — OPEN CART DRAWER
   ========================================================= */

document.addEventListener('submit', function (event) {
  var form = event.target;

  if (!form.matches('form[action*="/cart/add"]')) return;

  // Shopify/theme ko add-to-cart process karne do
  setTimeout(function () {
    var cartDrawer = document.querySelector('#cart-drawer');

    if (!cartDrawer) return;

    // Cart drawer ko open karo
    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer.setAttribute('open', '');
      cartDrawer.classList.add('is-open', 'active');
    }
  }, 500);
});


/* =========================================================
   PDP ACCORDION — ONLY ONE OPEN AT A TIME
   ========================================================= */

(function () {
  var accordions = document.querySelectorAll('.pdp-accordion details');

  if (!accordions.length) return;

  accordions.forEach(function (current) {
    current.addEventListener('toggle', function () {
      if (!current.open) return;

      accordions.forEach(function (other) {
        if (other !== current) {
          other.open = false;
        }
      });
    });
  });
})();


// pagination

(function () {
  var grids = document.querySelectorAll('[data-art-grid]');

  if (!grids.length) return;

  grids.forEach(function (grid) {

    var items = grid.querySelectorAll('.art-card');

    /* FIND ACTUAL PAGINATION */
    var pagination = grid.querySelector(
      ':scope > .pagination'
    );

    if (!pagination) return;

    /* MOVE PAGINATION OUTSIDE ART GRID */
    grid.parentNode.insertBefore(
      pagination,
      grid.nextSibling
    );


    var perPage = parseInt(
      grid.getAttribute('data-posts-per-page'),
      10
    );

    if (!perPage || perPage < 1) {
      perPage = 5;
    }


    var totalPages = Math.ceil(
      items.length / perPage
    );


    if (totalPages <= 1) {
      pagination.style.display = 'none';
      return;
    }


    pagination.style.display = 'flex';


    var currentPage = 1;

    var heading = document.querySelector(
  '[data-pagination-h1]'
);

function updateHeading() {
  if (!heading) return;

  heading.style.display =
    currentPage === 1 ? '' : 'none';
}


    function showPage(page) {

      currentPage = page;

      var start =
        (page - 1) * perPage;

      var end =
        start + perPage;


      items.forEach(function (item, index) {

        item.style.display =
          index >= start && index < end
            ? ''
            : 'none';

      });

      updateHeading();


      renderPagination();

    }


    function renderPagination() {

      pagination.innerHTML = '';


      /* PREVIOUS */

      if (currentPage > 1) {

        var prev =
          document.createElement('a');

        prev.href = '#';

        prev.className =
          'pagination-prev';

        prev.innerHTML = '‹';


        prev.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            showPage(
              currentPage - 1
            );

          }
        );


        pagination.appendChild(prev);

      }


      /* PAGE NUMBERS */

      for (
        var page = 1;
        page <= totalPages;
        page++
      ) {

        var button =
          document.createElement(
            page === currentPage
              ? 'span'
              : 'a'
          );


        button.textContent = page;


        if (page === currentPage) {

          button.className =
            'is-current';

          button.setAttribute(
            'aria-current',
            'page'
          );

        } else {

          button.href = '#';


          button.addEventListener(
            'click',
            (function (pageNumber) {

              return function (event) {

                event.preventDefault();

                showPage(pageNumber);

              };

            })(page)
          );

        }


        pagination.appendChild(button);

      }


      /* NEXT */

      if (currentPage < totalPages) {

        var next =
          document.createElement('a');

        next.href = '#';

        next.className =
          'pagination-next';

        next.innerHTML =
          'Next <span aria-hidden="true">›</span>';


        next.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            showPage(
              currentPage + 1
            );

          }
        );


        pagination.appendChild(next);

      }

    }


    showPage(1);

  });

})();




document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);

  if (params.get("customer_posted") !== "true") return;

  const wrapper = document.querySelector(".page-wrapper");

  if (!wrapper) return;

  document.documentElement.style.height = "auto";
  document.documentElement.style.overflowY = "auto";

  document.body.style.height = "auto";
  document.body.style.overflowY = "auto";

  wrapper.style.height = "auto";
  wrapper.style.minHeight = "100dvh";
  wrapper.style.overflow = "visible";
});



//headeraccount email button


(function () {
  const processedRoots = new WeakSet();

  function styleShopLogin() {
    const account = document.querySelector('shopify-account');
    if (!account || !account.shadowRoot) return;

    const accountRoot = account.shadowRoot;
    const loginForm = accountRoot.querySelector('shopify-login-form');
    if (!loginForm) return;

    const login = loginForm.querySelector('shop-login');
    if (!login || !login.shadowRoot) return;

    const loginRoot = login.shadowRoot;

    function applyStyles() {
      const button = loginRoot.querySelector(
        'button[data-testid="login-button"]'
      );

      if (button) {
        button.style.setProperty(
          'background-color', '#ece6d8', 'important'
        );
        button.style.setProperty(
          'border', '1px solid #181818', 'important'
        );
        button.style.setProperty(
          'border-radius', '0px', 'important'
        );

        const text = button.querySelector('span');
        if (text) {
          text.style.setProperty('color', '#000000', 'important');
        }
      }

      const spinner = loginRoot.querySelector(
        '[data-testid="shop-login-spinner"]'
      );

      if (spinner) {
        spinner.style.setProperty(
          'background-color', '#ece6d8', 'important'
        );
      }
    }

    applyStyles();

    // Reapply when Shopify renders or replaces the button.
    if (!processedRoots.has(loginRoot)) {
      processedRoots.add(loginRoot);

      new MutationObserver(applyStyles).observe(loginRoot, {
        childList: true,
        subtree: true
      });
    }
  }

  // Check again when the account popup or login component loads.
  function init() {
    styleShopLogin();

    const observer = new MutationObserver(styleShopLogin);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();





//All buttons border 

(function () {
  const observedRoots = new WeakSet();

  function applyStyles(root) {
    if (!root) return;

    // All buttons, inputs, form controls and marketing consent label
    const selectors = [
      'button',
      'input',
      'select',
      'textarea',
      'a.button',
      '[role="button"]',
      '.login-form__marketing-consent-label',
      '[class*="input"]',
      '[class*="field"]',
      '[class*="email"]'
    ].join(',');

    root.querySelectorAll(selectors).forEach(function (el) {
      // Square corners
      el.style.setProperty(
        'border-radius',
        '0px',
        'important'
      );

      // Museo Sans font
      el.style.setProperty(
        'font-family',
        '"museo-sans", sans-serif',
        'important'
      );
    });

    // Apply Museo Sans to nested text and SVG-free button content
    root.querySelectorAll(
      'button *, a.button *, [role="button"] *, .login-form__marketing-consent-label *'
    ).forEach(function (el) {
      el.style.setProperty(
        'font-family',
        '"museo-sans", sans-serif',
        'important'
      );
    });

    // Detect nested open Shadow DOMs
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) {
        watchRoot(el.shadowRoot);
      }
    });
  }

  function watchRoot(root) {
    if (!root || observedRoots.has(root)) return;

    observedRoots.add(root);

    applyStyles(root);

    new MutationObserver(function () {
      applyStyles(root);
    }).observe(root, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    // Main document
    watchRoot(document);

    // Shopify account and login components
    document.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) {
        watchRoot(el.shadowRoot);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Recheck when Shopify components load or update
  new MutationObserver(init).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
